// Hack to get the select native appearance in tests
export function getSelectAppearance(): 'native' | 'styled' {
  return 'styled'
}
